import { useCallback } from "react";
import { useBannerOrBlocker } from "..";
import { generatePluralText } from ".";
function useDurationText() {
  const {
    i18n: {
      durationUnit: durationUnitTexts
    },
    designVersion
  } = useBannerOrBlocker();
  return useCallback((duration, unit) => {
    return designVersion < 6 ? durationUnitTexts[unit] : generatePluralText(duration, durationUnitTexts["n1"][unit], durationUnitTexts["nx"][unit]);
  }, [durationUnitTexts]);
}
export { useDurationText };